// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__4P9Ca","large":"styles_large__3xBEL"};